import script from "./MyValue.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyValue.vue?vue&type=script&lang=ts&setup=true"

import "./MyValue.vue?vue&type=style&index=0&id=2415dcc8&lang=scss"

const __exports__ = script;

export default __exports__